import { SocialAuthService, SocialUser } from '@abacritt/angularx-social-login';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AppCommon } from 'src/app/api-providers/app-common';
import { UserDetailModel } from 'src/app/api-providers/models/login.model';
import { AppComponent } from 'src/app/app.component';
import { WorkTimeSummaryService } from 'src/app/api-providers/services/work-time-summary.service';


@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.scss']
})
export class UserProfileComponent implements OnInit, OnDestroy {

  totalWorkTime = '0 min';
  isWorking = false;
  workTimeTooltip = 'Not currently working';
  googleUser: SocialUser;
  loggedInUser: UserDetailModel;
  private workTimeSummarySubscription: Subscription;

  constructor(
    private router: Router,
    private authService: SocialAuthService,
    private workTimeSummaryService: WorkTimeSummaryService,
   
  ) {
    this.loggedInUser = AppCommon.getloggedInObject().user;
    this.googleUser = AppCommon.getGoogleUserObject();
  }

  ngOnInit(): void {
    this.workTimeSummarySubscription = this.workTimeSummaryService.summary$.subscribe(summary => {
      this.totalWorkTime = summary.totalWorkTimeLabel;
      this.isWorking = summary.isWorking;
      this.workTimeTooltip = summary.tooltip;
    });
    this.workTimeSummaryService.loadIfNeeded();
  }

  ngOnDestroy(): void {
    this.workTimeSummarySubscription?.unsubscribe();
  }

  signOut(): void {
    AppCommon.clearStorage();
    this.authService.signOut();
    AppComponent.staticCall.isLoggedIn = false;
    this.router.navigate(['/login']);
  }

  



}
